<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/on-demand/power-demand']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-6">
      <h2 class="col pb-2 m-0 title">
        {{ "POWER_DEMAND_DATA" | translate }}
        {{ "DETAILS" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "ONDEMANDPOWERDEMAND_SUBTITLE" | translate }}
      </h6>
    </div>
    @if (
      authService.isAuthorized([
        PermissionEnum.Ondemand_powerdemandregister_download,
      ])
    ) {
      <div
        class="col-md-5 d-flex justify-content-end align-items-center gap-2 pe-5"
      >
        <div class="download-button ps-3 pe-3 pb-2 pt-1" (click)="download()">
          <svg-icon
            alt="Download"
            class="hover-effect"
            src="assets/core/table/download.svg"
          ></svg-icon>
        </div>
      </div>
    }
  </div>
  <div #tableContainer class="table-container mt-5">
    <table>
      <thead>
        <tr>
          <td class="custom-width">
            {{ "TIME" | translate | uppercase }} {{ "INTERVAL" | translate }}
          </td>
          <td colspan="2">
            {{ "INSTANTANEOUS_PREFIX" | translate | uppercase }}
            {{ "ENERGYREGISTERS_ACTIVEPOWER" | translate | uppercase }}
          </td>
          <td colspan="2">
            {{ "ENERGYREGISTERS_ACTIVEPOWER" | translate | uppercase }}
            {{ "POWERDEMAND_SUFIX" | translate | uppercase }}
          </td>
          <td colspan="2">
            {{ "INSTANTANEOUS_PREFIX" | translate | uppercase }}
            {{ "ENERGYREGISTERS_REACTIVEPOWER" | translate | uppercase }}
          </td>
          <td colspan="2">
            {{ "ENERGYREGISTERS_REACTIVEPOWER" | translate | uppercase }}
            {{ "POWERDEMAND_SUFIX" | translate | uppercase }}
          </td>
          <td colspan="2">
            {{ "INSTANTANEOUS_PREFIX" | translate | uppercase }}
            {{ "ENERGYREGISTERS_APPARENTPOWER" | translate | uppercase }}
          </td>
          <td colspan="2">
            {{ "ENERGYREGISTERS_APPARENTPOWER" | translate | uppercase }}
            {{ "POWERDEMAND_SUFIX" | translate | uppercase }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td class="table-name-number">
            <span>{{ item.meterTime | date: "dd MMM yyyy, h:mm a" }}</span>
          </td>

          <!-- Instantaneous Active Power -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.instantaneousActivePowerImport + ' W'">
                {{ item.instantaneousActivePowerImport  == null ? "N/A" :
                   item.instantaneousActivePowerImport | unitConverter: "W" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.instantaneousActivePowerExport + ' W'">
                {{ item.instantaneousActivePowerExport  == null ? "N/A" :
                  item.instantaneousActivePowerExport | unitConverter: "W" }}
              </span>
            </div>
          </td>

          <!-- Power Demand Active Power -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.maxDemandActivePowerImport + ' W'">
                {{ item.maxDemandActivePowerImport  == null ? "N/A" :
                   item.maxDemandActivePowerImport | unitConverter: "W" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.maxDemandActivePowerExport + ' W'">
                {{ item.maxDemandActivePowerExport  == null ? "N/A" :
                  item.maxDemandActivePowerExport | unitConverter: "W" }}
              </span>
            </div>
          </td>

          <!-- Instantaneous Reactive Power -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span
                [attr.title]="item.instantaneousReactivePowerImport + ' VAR'"
              >
                {{ item.instantaneousReactivePowerImport == null ? "N/A" :
                  item.instantaneousReactivePowerImport | unitConverter: "VAR"
                }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span
                [attr.title]="item.instantaneousReactivePowerExport + ' VAR'"
              >
                {{ item.instantaneousReactivePowerExport == null ? "N/A" :
                  item.instantaneousReactivePowerExport | unitConverter: "VAR"
                }}
              </span>
            </div>
          </td>

          <!-- Power Demand Reactive Power -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span
                [attr.title]="item.maxDemandReactivePowerImport + ' VAR'"
              >
                {{ item.maxDemandReactivePowerImport == null ? "N/A" :
                  item.maxDemandReactivePowerImport | unitConverter: "VAR"
                }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span
                [attr.title]="item.maxDemandReactivePowerExport + ' VAR'"
              >
                {{ item.maxDemandReactivePowerExport == null ? "N/A" :
                  item.maxDemandReactivePowerExport | unitConverter: "VAR"
                }}
              </span>
            </div>
          </td>

          <!-- Instantaneous Apparent Power -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span
                [attr.title]="item.instantaneousApparentPowerImport + ' VA'"
              >
                {{ item.instantaneousApparentPowerImport == null ? "N/A" :
                  item.instantaneousApparentPowerImport | unitConverter: "VA"
                }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span
                [attr.title]="item.instantaneousApparentPowerExport + ' VA'"
              >
                {{ item.instantaneousApparentPowerExport == null ? "N/A" :
                  item.instantaneousApparentPowerExport | unitConverter: "VA"
                }}
              </span>
            </div>
          </td>

          <!-- Power Demand Apparent Power -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span
                [attr.title]="item.maxDemandApparentPowerImport + ' VA'"
              >
                {{ item.maxDemandApparentPowerImport == null ? "N/A" :
                  item.maxDemandApparentPowerImport | unitConverter: "VA"
                }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span
                [attr.title]="item.maxDemandApparentPowerExport + ' VA'"
              >
                {{ item.maxDemandApparentPowerExport == null ? "N/A" :
                  item.maxDemandApparentPowerExport | unitConverter: "VA"
                }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfCommands"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    ></app-pagination>
  </div>
</div>
